import React, { useState } from "react";
import { notify } from "../../../generic";
import { Modal } from "react-responsive-modal";
import { Col, Row } from "react-bootstrap";
import CtaButton from "../../../components/Interface/CtaButton";

function InputDialog({
  open,
  setOpen,
  title,
  label,
  categorieName,
  categorieId,
  onSubmitAction,
  isNumeric = false,
  errorManagement = [],
  loading
}) {
  const [entityName, setEntityName] = useState("");
  const [entityNameError, setEntityNameError] = useState(false);
  const [numericError, setNumericError] = useState(false);

  const handleModalClosure = () => {
    setEntityName("");
    setEntityNameError(false);
    setOpen(false);
  };

  const handleModalSubmission = async () => {
    setEntityName("");
    setOpen(false);
    onSubmitAction({
      value: entityName
    });
  };

  const handleSubmit = ({ key }) => {
    if (key === "Enter" && open) {
      if (entityName.length > 0) handleModalSubmission();
      else setEntityNameError(true);
    } else {
      setEntityNameError(false);
    }
  };

  const handleChange = target => {
    let { value } = target;

    if (isNumeric) value = value.replace(",", ".");

    setEntityName(value);
  };

  return (
    <Modal closeIcon={<></>} open={open} onClose={handleModalClosure}>
      <Row>
        <Col xs={12}>
          <p>{title}</p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <label>{label}</label>
          <input
            name="entityName"
            type="text"
            className={`form-control ${entityNameError ? "has-error" : ""}`}
            type={isNumeric ? "number" : "text"}
            pattern={isNumeric ? "[0-9]+([\\,|\\.][0-9]+)?" : null}
            onChange={({ target }) => handleChange(target)}
            onKeyDownCapture={handleSubmit}
            value={entityName}
          />
          <span className={`invalid-feedback ${entityNameError ? "show" : ""}`}>
            La valeur entrée est incorrecte
          </span>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <CtaButton
            action={() => handleSubmit({ key: "Enter" })}
            text="Ajouter"
            busy={loading}
          />
          <a
            className="btn btn-default  float-end"
            onClick={handleModalClosure}
          >
            Annuler
          </a>
        </Col>
      </Row>
    </Modal>
  );
}

export default InputDialog;
